export enum GenericRelationship {
    EMPLOYEE = 'Employee',
    FAMILY_MEMBER_OR_COVERED_DEPENDENT = 'Employee\'s family member or covered dependent',
}